import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringInjection'
})
export class StringInjectionPipe implements PipeTransform {

  transform(value: string, results: any): unknown {
    // below regex matches {{key}} or {{ key }} via optional white space
    // it also grabs just the `key` via a group accessed as the 2nd element [1]
    // key is then looked for in `results`, otherwise the key string itself is returned.
    const templateLiterals = value.matchAll(/{{\s*(.+?)\s*}}/g);
    let transformedValue = value;
    if (templateLiterals) {
      for (const templateLiteral of templateLiterals) {
        const matchedString = templateLiteral[0] // {{ key }}
        const matchedGroup = templateLiteral[1] // key
        transformedValue = transformedValue.replace(matchedString, results[matchedGroup] || matchedGroup);  
      }
    }
    
    return transformedValue;
  }
}